<template>
  <svg
    width="25"
    height="53"
    viewBox="0 0 25 53"
    fill="none"
    class="icon-lightning-filled"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.7978 0.212018L0.910086 31.5597L12.0201 30.7676L6.35493 52.27L24.8912 23.699L13.9253 24.3833L20.7978 0.212018Z"
      fill="#110F13"
    />
  </svg>
</template>
